import { render, staticRenderFns } from "./h5Header.vue?vue&type=template&id=613ad6e8&scoped=true&"
import script from "./h5Header.vue?vue&type=script&lang=js&"
export * from "./h5Header.vue?vue&type=script&lang=js&"
import style0 from "./h5Header.vue?vue&type=style&index=0&id=613ad6e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ad6e8",
  null
  
)

export default component.exports